<template>
  <div class="dialog-app-panel" :class="showDrawPanel ? 'dialog-show' : ''">
    <app-panel
      :isExpand="showDrawPanel"
      :title="'图纸【' + buildInfo.buildingName + '】'"
      :transparent="true"
      :width="1000"
      isScreen
      @screen="handleScreenPanel"
      @cancel="handleClosePanel"
    >
      <div class="floors" v-if="buildInfo">
        <div
          class="floor-item"
          v-for="item in buildInfo.floorInfo"
          :key="item.buildingCode"
          :class="item.buildingCode == floorInfo.buildingCode ? 'active' : ''"
          @click="handleFloors(item)"
        >
          <i class="el-icon-caret-right"></i>
          <div class="floor-title">
            {{ item.buildingName }}
          </div>
        </div>
      </div>
      <!-- canvas图纸 -->
      <div class="canvasMain">
        <div
          class="canvasMainT"
          :style="{
            width: vW + '%',
            height: vH + '%',
            marginTop: getMarginTop + 'px',
            marginLeft: getMarinLeft + 'px',
          }"
        >
          <!--  -->
          <!-- src="/images/theme/newDark/default-drawing1.jpg" -->
          <img id="floorImg" :src="floorInfo ? getImgPath(floorInfo.fileCode) : ''" />
          <canvas
            id="mycanvas"
            style="cursor: all-scroll"
            @mousewheel="mouseScroll"
            @DOMMouseScroll="mouseScroll"
            @mousedown="handleDomMoveStart"
            :width="cW"
            :height="cH"
          ></canvas>
        </div>
      </div>
      <div class="coord">
        <span> 【 缩放比例 {{ vW }}% 】 </span>
        【相对坐标 X：{{ pointX }} ，Y：{{ pointY }} 】
      </div>
      <div
        v-if="showDeviceTip"
        class="canvasTip"
        :style="{
          left: tipStyle.left + 'px',
          top: tipStyle.top + 'px',
        }"
      >
        <component
          :is="showDeviceName"
          :data="deviceInfo"
          :options="deviceInfo"
          :pointCode="deviceInfo.pointCode"
          @tipClose="showDeviceTip = false"
          @closeTip="showDeviceTip = false"
          @handleDel="handleDelPoint"
          @updateCallBack="handleUpdatePoint"
        >
        </component>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClosePanel" type="info" :loading="subLoading">
          {{ panelType == 2 ? "关闭" : "取消" }}
        </el-button>

        <el-button
          type="primary"
          v-if="panelType != 2"
          :loading="subLoading"
          @click="handleSavePanel()"
        >
          {{ subLoading ? "提交中" : "保存" }}
        </el-button>
      </span>
    </app-panel>

    <el-dialog
      title="新增巡更点"
      :visible.sync="addDialog"
      width="400px"
      :append-to-body="true"
      :before-close="handleCloseDialog"
    >
      <el-form
        :model="pointForm"
        :rules="pointRules"
        label-width="100px"
        ref="refPatrolForm"
      >
        <el-form-item prop="name" label="巡更点名称">
          <el-input v-model="pointForm.name"></el-input>
        </el-form-item>
        <el-form-item label="打卡方式" prop="type">
          <el-radio-group v-model="pointForm.type">
            <!-- <el-radio label="0" disabled>GPS</el-radio> -->
            <el-radio label="1">二维码</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">取消</el-button>
        <el-button type="primary" @click="handleSaveDialog">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Bus } from "$utils";
import deviceMap from "@src/modules/cameraList/components/deviceMap";
import cameraTip from "@src/modules/realTimeAlarm/components/canvasTip.vue";
import pointTip from "./pointDetails.vue";
import appPanel from "@src/components/business/app-panel/index.vue";
import { api } from "../api";
export default {
  name: "floor-draw",
  props: {
    panelType: {
      type: Number,
      default: 0,
    },
  },
  mixins: [deviceMap],
  components: {
    appPanel,
    cameraTip,
    pointTip,
  },
  computed: {
    // 视频与容器顶部距离计算
    getMarginTop() {
      return this.marginTop + this.moveYDistance;
    },
    // 视频与容器左边距离计算
    getMarinLeft() {
      return this.marginLeft + this.moveXDistance;
    },
  },
  watch: {
    getMarinLeft() {
      this.matchTip();
    },
    getMarginTop() {
      this.matchTip();
    },
    vH() {
      this.$nextTick(() => {
        this.getCanvasWH();
        this.matchTip();
      });
    },
  },
  data() {
    return {
      cW: 0,
      cH: 0,
      showDrawPanel: false,
      floorInfo: {},
      subLoading: false,
      pointX: 0,
      pointY: 0,
      canvasList: [], //本次计划选中的点位
      allCanvasList: [], //该楼层下所有点位
      canvasCameraList: [], //该楼层下所有设备，摄像机
      setTimeNum: 0,
      addDialog: false,
      imgPoint: null,
      imgCamera: null,
      buildInfo: {},
      pointForm: {
        name: "",
        type: "1",
      },
      pointRules: {
        name: [{ required: true, message: "请输入巡更点名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择方式", trigger: "blur" }],
      },
      tipStyle: { left: 0, top: 0 },
      deviceInfo: {},
      showDeviceTip: false,
      showDeviceName: "",
      tipType: "canvasList", //当前tip的数据类型
    };
  },
  created() {
    this.imgPoint = new Image();
    this.imgCamera = new Image();
    this.imgPoint.src = require("/public/images/theme/newDark/map/pointQr-InActive.png");
    this.imgCamera.src = require("/public/images/theme/newDark/map/cameraDefault.png");
  },
  mounted() {
    this.canvasClick();
    this.getCanvasWH();
    let that = this;
    window.onresize = function () {
      that.getCanvasWH();
    };
  },
  beforeDestroy() {
    clearInterval(this.handleClickTime);
    window.onresize = null;
  },
  methods: {
    handleFloors(item) {
      if (item.buildingCode == this.floorInfo.buildingCode) {
        return;
      }
      this.floorInfo = JSON.parse(JSON.stringify(item));
      this.clearCanvas();
      this.getIndoorDeviceList(item);
      this.getIndoorPoint(item);
    },
    handleScreenPanel() {
      this.getCanvasWH();
      this.matchTip();
    },
    handleSaveDialog() {
      this.$refs["refPatrolForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.canvasList[this.canvasList.length - 1].name = this.pointForm.name;
        this.canvasList[this.canvasList.length - 1].type = this.pointForm.type;
        this.$refs.refPatrolForm.resetFields();
        this.mathCanvas();
        this.addDialog = false;
      });
    },
    handleCloseDialog() {
      this.$refs.refPatrolForm.resetFields();
      this.canvasList.splice(this.canvasList.length - 1, 1);

      this.mathCanvas();
      this.addDialog = false;
    },
    canvasClick() {
      let that = this;
      var canvas = document.getElementById("mycanvas");
      var x, y;
      canvas.addEventListener("click", function (e) {
        // console.log(e);
        // console.log(that.setTimeNum);
        that.handleClickTime && clearInterval(that.handleClickTime);
        if (that.setTimeNum < 2) {
          // &&(that.panelType == 0 || that.panelType == 1)
          // 编辑模式
          that.handleClickCanvas(e);
        }
      });
      canvas.addEventListener(
        "mousemove",
        function (e) {
          if (e.pageX || e.pageY) {
            x = e.offsetX;
            y = e.offsetY;
          } else {
            x =
              e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            y = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
          }
          that.pointX = x;
          that.pointY = y;
        },
        false
      );
      canvas.addEventListener(
        "mousedown",
        function (e) {
          that.setTimeNum = 0;
          that.handleClickTime = setInterval(() => {
            that.setTimeNum++;
          }, 100);
        },
        false
      );
    },
    // 获取设备详情
    // canvasCameraList: 摄像机
    // canvasList: 点位
    getDeviceDetail(info, type) {
      this.deviceInfo = {};
      this.tipType = type;
      if (type == "canvasList") {
        // 触发本次计划的点位
        this.deviceInfo = {
          pointName: info.name,
          pointCode: this.panelType == 2 ? info.pointCode : "", //防止删除复用的点位，不传Code,只做本地修改
          location: "室内 / " + info.floorName,
          punchType: info.type,
          number: info.number,
          x: info.x,
          y: info.y,
          width: info.width,
          height: info.height,
        };
        this.showDeviceName = "pointTip";
        this.showDeviceTip = true;
        this.matchTip();
        return;
      }
      if (type == "allCanvasList") {
        if (this.panelType != 2) {
          this.canvasList.push({ ...info });
          this.mathCanvas();
        } else {
          // 触发该楼层下所有点位
          this.deviceInfo = {
            pointName: info.name,
            pointCode: info.pointCode,
            location: "室内 / " + info.floorName,
            punchType: info.type,
            number: info.number,
            x: info.x,
            y: info.y,
            width: info.width,
            height: info.height,
          };
          this.showDeviceName = "pointTip";
          this.showDeviceTip = true;
          this.matchTip();
        }

        return;
      }

      this.$fetch(api.getDeviceDetail, {
        deviceId: info.deviceId,
      }).then((res) => {
        if (res.success) {
          this.deviceInfo = res.returnObj.deviceInfo;
          this.showDeviceName = "cameraTip";
          this.showDeviceTip = true;
          this.matchTip();
        } else {
          this.$message.error("获取设备信息失败");
        }
      });
    },
    // 图纸设备点击回调
    // canvasCameraList: 摄像机，点位
    // canvasList: 点位
    handleCameraClick(e, type) {
      return new Promise((resolve) => {
        let x = e.offsetX;
        let y = e.offsetY;
        let possiblyDevice = [];
        if (!this[type].length) {
          resolve(false);
        }
        console.log(this[type]);
        this[type].forEach((el, index) => {
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          let abscissa = el.abscissa || el.x;
          let ordinate = el.ordinate || el.y;
          let scope = Math.pow(x - abscissa * wb, 2) + Math.pow(y - ordinate * hb, 2);
          if (scope < 25 * 25) {
            let obj = {
              ...el,
              // number: index, //选中点位的下标
              distance: scope - 25 * 25,
            };
            possiblyDevice.push(obj);
          }
        });
        // 如果存在多个符合要求的设备,按距离取最近的设备
        if (possiblyDevice.length > 1) {
          possiblyDevice = possiblyDevice.sort((a, b) => {
            return a.distance - b.distance;
          });
        }
        if (possiblyDevice.length) {
          this.getDeviceDetail(possiblyDevice[0], type);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    },
    // 更新点位信息
    handleUpdatePoint(name) {
      this.canvasList[this.deviceInfo.number].name = name;
      this.showDeviceTip = false;
    },
    // 在点位管理里可以将未保存的点位本地删除
    handleDelPoint() {
      console.log(this.deviceInfo);
      if (!this.deviceInfo.pointCode) {
        // 本地删除
        this.canvasList.splice(this.deviceInfo.number, 1);
        this.mathCanvas();
      } else {
        //更新库数据
        this.getIndoorPoint();
      }
      this.showDeviceTip = false;
    },
    // canvasCameraList: 摄像机
    // canvasList: 点位
    async handleClickCanvas(e) {
      console.log(e);
      // this.clearCanvas();
      let x = e.offsetX;
      let y = e.offsetY;
      // 如果点击的是设备,停止打点
      let clickDevice = await this.handleCameraClick(e, "canvasCameraList");
      console.log(clickDevice);
      if (!clickDevice) {
        let clickPoint = await this.handleCameraClick(e, "canvasList");
        if (clickPoint) {
          return;
        }
        let clickAllPoint = await this.handleCameraClick(e, "allCanvasList");
        if (clickAllPoint) {
          return;
        }
      } else {
        return;
      }

      if (this.panelType == 2) {
        return;
      }
      // 添加新的标记点
      this.canvasList.push({
        buildName: this.floorInfo.parentName,
        buildingId: this.floorInfo.parentCode,
        floorId: this.floorInfo.buildingCode,
        floorName: this.floorInfo.buildingName,
        width: this.cW, //原始大小
        height: this.cH, //原始大小
        x: x,
        y: y,
        number: this.canvasList.length,
      });

      this.mathCanvas();
      this.addDialog = true;
    },
    getCanvasWH() {
      // 分辨率发生变化
      this.cH = document.querySelector(".canvasMainT").offsetHeight;
      this.cW = document.querySelector(".canvasMainT").offsetWidth;
      this.mathCanvas();
    },
    // canvasCameraList,摄像机--canvasTip
    // canvasList,点位--pointTip
    matchTip() {
      let list = [];
      list = this[this.tipType];
      // console.log(list);
      if (list.length && this.showDeviceTip) {
        list.forEach((el) => {
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          let abscissa = el.abscissa || el.x;
          let ordinate = el.ordinate || el.y;
          // 显示该设备tip
          if (
            (this.showDeviceName == "cameraTip" &&
              el.deviceId == this.deviceInfo.deviceId) ||
            (this.showDeviceName == "pointTip" && el.number == this.deviceInfo.number)
          ) {
            this.tipStyle.left = Math.round(abscissa * wb + this.getMarinLeft - 135);
            this.tipStyle.top = Math.round(ordinate * hb + this.getMarginTop + 25);
          }
        });
      }
    },
    mathCanvas() {
      this.clearCanvas();
      // console.log(this.allCanvasList);
      let ctx = this.initCanvas();
      // 该楼层下所有点位
      if (this.allCanvasList.length) {
        this.allCanvasList.forEach((el) => {
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          this.$nextTick(() => {
            ctx.drawImage(
              this.imgPoint,
              Math.round(el.x * wb - 25),
              Math.round(el.y * hb - 25),
              50,
              50
            );
          });
        });
      }
      // 巡更点位打点
      if (this.canvasList.length) {
        this.canvasList.forEach((el, index) => {
          el.number = index;
          // 只渲染当前楼层点位
          if (el.floorId != this.floorInfo.buildingCode) {
            return;
          }
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          this.$nextTick(() => {
            // 绘制图标
            ctx.drawImage(
              this.imgPoint,
              Math.round(el.x * wb - 25),
              Math.round(el.y * hb - 25),
              50,
              50
            );
            // 绘制序号
            ctx.beginPath();
            ctx.arc(
              Math.round(el.x * wb - 8),
              Math.round(el.y * hb - 8),
              8,
              0,
              Math.PI * 2,
              true
            );
            ctx.fillStyle = "#3E76E6";
            ctx.fill();
            ctx.strokeStyle = "#3E76E6";
            ctx.stroke();
            ctx.font = "12pt Arial";
            ctx.fillStyle = "#ffffff";
            ctx.fillText(
              el.number + 1,
              Math.round(el.x * wb - 13),
              Math.round(el.y * hb - 2)
            );
            // if (el.name) {
            //   ctx.font = "12pt Arial";
            //   ctx.fillStyle = "#ff0000";
            //   ctx.fillText(
            //     "【名称：" + el.name + "】",
            //     Math.round(el.x * wb - 50) < 0 ? 0 : Math.round(el.x * wb - 50),
            //     Math.round(el.y * hb - 30) < 0 ? 0 : Math.round(el.y * hb - 30)
            //   );
            // }
          });
        });
      }
      // 摄像机打点
      if (this.canvasCameraList.length) {
        this.canvasCameraList.forEach((el) => {
          let wb = this.cW / el.width;
          let hb = this.cH / el.height;
          this.$nextTick(() => {
            ctx.drawImage(
              this.imgCamera,
              Math.round(el.abscissa * wb - 25),
              Math.round(el.ordinate * hb - 25),
              50,
              50
            );
          });
        });
      }
    },
    handleClosePanel() {
      this.handleResetCanvas();
      this.$app.AppInstance.handleMiniPlay(); //关闭播放器
      this.showDrawPanel = false;
      this.$emit("handleClosePoint");
    },
    // 清除画布内容
    handleResetCanvas(isClearList = true) {
      this.clearCanvas();
      this.vW = 100;
      this.vH = 100;
      this.marginTop = 0;
      this.moveYDistance = 0;
      this.marginLeft = 0;
      this.moveXDistance = 0;
      this.pointX = 0;
      this.pointY = 0;
      isClearList ? (this.canvasList = []) : "";
      this.showDeviceTip = false;
    },
    handleSavePanel(type = true) {
      console.log(this.canvasList);
      this.$emit("handleAddPoint", this.canvasList);
      this.$nextTick(() => {
        type == true ? this.handleClosePanel() : "";
      });
    },

    getImgPath(fileCode) {
      return fileCode ? Bus.imgPath(fileCode) : "";
    },
    handleOpenPanel(info, planInfo, buildInfo) {
      this.floorInfo = JSON.parse(JSON.stringify(info));
      this.buildInfo = JSON.parse(JSON.stringify(buildInfo));
      this.showDrawPanel = true;
      this.getIndoorDeviceList(this.floorInfo);
      this.getIndoorPoint(this.floorInfo);
      // console.log("楼层信息", info);
      console.log("本次计划选中点位", planInfo);
      // console.log("楼栋信息", buildInfo);
      if (planInfo) {
        let canvasList = [];
        planInfo.patrolPlanPointList.length &&
          planInfo.patrolPlanPointList.forEach((item, index) => {
            if (item.location == "室内" || item.area == "室内") {
              // &&item.floorId == this.floorInfo.buildingCode
              console.log(item);
              canvasList.push({
                buildName: item.buildName,
                buildingId: item.buildingId,
                floorId: item.floorId,
                floorName: item.floorName,
                width: item.width,
                height: item.altitude || item.height,
                x: item.longitude || item.x,
                y: item.latitude || item.y,
                coord: [item.longitude || item.y, item.latitude || item.x],
                pointCode: item.pointCode, //已有点位
                name: item.pointName || item.name,
                type: item.punchType || item.type,
                number: index, //序号
                sortNum: 0,
              }); //点位集合
            }
          });
        this.canvasList = [...canvasList];
        this.mathCanvas();
      }
    },
    //查询楼层下的巡更点位
    getIndoorPoint() {
      console.log(this.floorInfo);
      let params = {
        floorId: this.floorInfo.buildingCode, //所在位置id
      };
      this.$fetch(api.patrolplan.queryAllPoint, params).then((res) => {
        if (res.success) {
          let list = res.returnObj;
          let allCanvasList = [];
          list.length &&
            list.forEach((item, index) => {
              if (item.location == "室内" || item.area == "室内") {
                // &&item.floorId == this.floorInfo.buildingCode
                console.log(item);
                allCanvasList.push({
                  buildName: item.buildName,
                  buildingId: item.buildingId,
                  floorId: item.floorId,
                  floorName: item.floorName,
                  width: item.width,
                  height: item.altitude || item.height,
                  x: item.longitude || item.x,
                  y: item.latitude || item.y,
                  coord: [item.longitude || item.y, item.latitude || item.x],
                  pointCode: item.pointCode, //已有点位
                  name: item.pointName || item.name,
                  type: item.punchType || item.type,
                  number: index, //序号
                  sortNum: 0,
                }); //点位集合
              }
            });
          this.allCanvasList = [...allCanvasList];
          this.mathCanvas();
        } else {
          this.$message.error("获取该楼层巡更点位失败");
        }
      });
    },
    // 查询楼层下设备
    getIndoorDeviceList(info) {
      let params = {
        buildingCode: info.buildingCode, //所在位置id
        deviceTypeList: ["10"], //摄像机
      };
      this.handleResetCanvas(false);
      this.$fetch(api.getIndoorDeviceList, params).then((res) => {
        if (res.success) {
          this.canvasCameraList = res.returnObj;
          this.mathCanvas();
        } else {
          this.$message.error("获取该楼层设备失败");
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.canvasTip {
  z-index: 2;
  position: absolute;
  background: rgba(11, 18, 35, 0.35);
}
.dialog-app-panel {
  //   pointer-events: none;
  z-index: 10;
}
:deep .app-side-panel {
  pointer-events: all;
  &__body {
    flex-direction: row;
    overflow: hidden;
  }
}
.coord {
  //   width: 100%;
  display: flex;
  justify-content: space-between;
  position: absolute;
  right: 0%;
  min-width: 210px;
  background: rgba(13, 18, 28, 0.7);
  padding: 5px 10px;
  color: #fff;
}
.floors {
  max-width: 150px;
  min-width: 100px;
  padding-right: 8px;
  .floor-item {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    color: #42526e;
    cursor: pointer;
    i {
      font-size: 20px;
      margin-right: 8px;
      opacity: 0;
    }
    &:hover {
      color: black;
    }
    &.active {
      color: black;
      font-weight: bold;
      i {
        opacity: 1 !important;
      }
    }
    .floor-name {
      letter-spacing: 3px;
    }
  }
}
.canvasMain {
  position: relative;
  background: rgba(128, 128, 128, 0.5);
  width: 100%;
  height: 100%;
  overflow: hidden;

  .canvasMainT {
    position: absolute;
    #floorImg {
      width: 100%;
      height: 100%;
      position: absolute;
    }
    canvas {
      position: absolute;
    }
  }
}
</style>
